import React from 'react';
import {Link} from "react-router-dom";

export default function TradingAgreementNotice() {
    return (
        <span >
            <span className={'small-print'}>By submitting this order you agree to Costcutter Supermarkets Group Ltd Terms & Conditions as detailed in your <Link
                className={'trading-agreement-link'} to={'/trading-agreement'} title={'Trading Agreement'}>Trading Agreeement</Link>.
            </span>
            <span className={'small-print'}>Please click <Link className={'trading-agreement-link'} to={'/trading-agreement'}
                                                           title={'Trading Agreement'}>here</Link> to access the latest version of the Trading Agreement.
            </span>
        </span>
    )
}



